// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".miniScoreHeight[data-v-7ee867bf]{border-left:1px solid #000;border-right:1px solid #000}", ""]);
// Exports
module.exports = exports;
